import styled from 'styled-components';

type Overflow = 'auto' | 'scroll' | 'visible' | 'hidden';

type PopoverContentProps = {
  /**
   * Used as a dropdown menu with MenuItemGroup.
   */
  $asMenu?: boolean;
  $maxWidth?: number;
  $maxHeight?: number;
  $width?: number;
  $overflow?: Overflow;
};

export const PopoverContent = styled.div<PopoverContentProps>`
  padding: ${({ $asMenu }) => ($asMenu ? '8px 16px' : '8px')};
  ${({ $width }) => $width && `width: ${$width}px;`};
  ${({ $maxWidth }) => $maxWidth && `max-width: ${$maxWidth}px;`};
  ${({ $maxHeight }) => $maxHeight && `max-height: ${$maxHeight}px;`};
  ${({ $overflow }) => $overflow && `overflow: ${$overflow};`};
`;
